

export const ADD_TO_CART="addToCart";
export const REMOVED_FROM_CART="removedFromCart";
export const REMOVE_ONE_FROM_CART="removeOneFromCart";
export const CART_RESET="cartReset";
export const ADD_TO_CART_ERROR="addToCartError";